import { type ISubJobSchedule } from '@/interfaces'

export class SubJobSchedule implements ISubJobSchedule {
	design: Date | null
	estimatingKickoff: Date | null
	signedQuote: Date | null
	detailing: Date | null
	productionKickoff: Date | null
	graphics: Date | null
	ship: Date | null
	postShowReview: Date | null
	constructor(data?: Partial<ISubJobSchedule>) {
		this.design = data?.design ? new Date(data.design) : null
		this.estimatingKickoff = data?.estimatingKickoff ? new Date(data.estimatingKickoff) : null
		this.signedQuote = data?.signedQuote ? new Date(data.signedQuote) : null
		this.detailing = data?.detailing ? new Date(data.detailing) : null
		this.productionKickoff = data?.productionKickoff ? new Date(data.productionKickoff) : null
		this.graphics = data?.graphics ? new Date(data.graphics) : null
		this.ship = data?.ship ? new Date(data.ship) : null
		this.postShowReview = data?.postShowReview ? new Date(data.postShowReview) : null
	}
}
